<template>
  <ul class="TagList flex flex-wrap">
    <li
      v-for="(tag, i) in tags"
      :key="tag.slug || i"
      class="min-w-12 mr-2 mb-2 px-2 py-1 text-gray-700 text-xs text-center border"
      :class="cc(tag)"
      @click="gotoTag(tag.label)"
    >
      {{ tag.label }}
      <slot :tag="tag" />
    </li>
  </ul>
</template>

<script>
import List from '@/lib/list'

export default {
  name: 'LmTagList',
  props: {
    tags: {
      type: Array,
      required: true
    },
    navDisable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTags: List.getActiveTags()
    }
  },
  computed: {
    cc() {
      return tag => {
        return [
          {'cursor-pointer hover:text-gray-900': !this.navDisable},
          {
            'bg-highlightBaseLight text-highlight border-highlightBase': this.activeTags.some(
              t => t && List.tagMatch(t, tag)
            )
          }
        ]
      }
    }
  },
  watch: {
    $route() {
      this.activeTags = List.getActiveTags() // refresh active tags list
    }
  },
  methods: {
    gotoTag(tag) {
      if (!this.navDisable) this.$router.pushQuery({search: `tag:"${tag}"`})
    }
  }
}
</script>
